
"use client";

import { title } from "@/components/primitives";
import { Accordion, AccordionItem } from "@heroui/accordion";
import { Avatar } from "@heroui/avatar";
import { Card, CardBody, CardFooter } from "@heroui/card";
import { Image } from "@heroui/image";
import { Spacer } from "@heroui/spacer";
import { backOut } from "framer-motion";
import { useLcgContext } from "@/config/context-conn";
import { useEffect, useState } from "react";
import { Button } from "react-aria-components";
import { Products, ProductModel } from "../acount/ProductModel";
import  ProductSelector  from "../acount/ProductSelector";
import ProductPresenter, { ProductPresenterHeader }  from "./PrroductPresenter";

export default function PayPlan()
{

  const AvaliableHeaders : ProductPresenterHeader[] = [
    {
      label : "Posilovna",
      object : "WorkoutGym",
      image : <svg fill="#000000" height="60px" width="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" >
                <path d="M447.929,117.727c-4.293-6.572-13.195-7.529-18.766-2.484c-22.59,20.452-24.27,21.849-30.17,27.755l-32.16-4.431
                  l-3.264,8.831c4.075,8.507,4.667,18.33,1.573,27.29l6.408,0.882c-8.368,11.835-15.685,24.353-21.877,37.417
                  c-1.032,20.236,0.823,40.573,5.581,60.402c7.337-34.409,22.545-66.541,44.397-93.947l12.835,1.768
                  c9.819,1.36,18.935-5.505,20.295-15.38c0.821-5.957-1.386-11.622-5.426-15.479l18.201-16.479
                  C450.108,129.75,451.287,122.867,447.929,117.727z"/>

                <path d="M352.064,102.663c-6.429-2.381-13.562,0.909-15.938,7.335l-6.275,16.975c8.805-0.312,17.083,2.597,23.59,7.749
                  L359.4,118.6C361.775,112.174,358.491,105.038,352.064,102.663z"/>

                <path d="M369.79,470.721c20.18-5.182,35.096-23.494,35.096-45.291c0-8.227-2.132-15.954-5.863-22.668
                  c-4.042-7.275-9.965-13.354-17.116-17.587l-30.822-78.791c-13.526-34.577-18.247-71.586-14.162-107.891
                  c-1.281,0.209,0.212,0.023-25.228,2.878c-3.45,38.461,1.977,77.483,16.283,114.054l24.446,62.492l-15.738-2.092l-14.644-37.436
                  l-3.796,34.985l-45.93-6.105c-3.413,5.495-7.955,10.017-14.021,13.427l7.677,0.371c7.447,0.36,13.691,6.185,14.055,13.632
                  c0.426,8.723-6.759,15.553-15.069,15.133c-5.998-0.29-45.499-2.2-50.707-2.451c-7.938-0.384-14.063-7.131-13.679-15.069
                  c0.335-6.908,5.673-14.134,16.396-13.614c-7.172-5.028-12.503-12.379-15.005-20.781l-25.212-3.351l12.442-39.078
                  c0.861-2.705,1.161-5.558,0.88-8.383l-4.25-42.801c-39.847-7.433-38.686-7.036-42.733-8.495l5.078,51.134l-12.853,40.372
                  c-40.851,2.645-73.171,36.596-73.171,78.115c0,22.908,9.84,43.516,25.521,57.834l-11.571,11.573
                  c-3.517,3.517-4.167,9.154-1.188,13.137c3.713,4.963,10.785,5.337,15.004,1.119l14.27-14.27
                  c10.844,5.679,23.175,8.909,36.265,8.909c11.673,0,204.623-29.823,204.623-29.823l34.605,35.132
                  c3.845,3.903,10.129,3.954,14.036,0.106c3.904-3.845,3.952-10.129,0.106-14.035L369.79,470.721z M187.181,427.867
                  c-1.206,23.775-20.525,43.094-44.3,44.299c-27.767,1.407-50.576-21.402-49.169-49.169c1.205-23.776,20.523-43.094,44.299-44.3
                  C165.778,377.289,188.587,400.099,187.181,427.867z"/>

                <path d="M276.345,4.526c-21.323-11.089-47.407-1.002-55.722,21.548c-6.856,18.595,1.331,39.766,18.915,48.909
                  c21.323,11.088,47.404,1.002,55.72-21.547C302.116,34.841,293.93,13.67,276.345,4.526z"/>

                <path d="M329.08,145.061l-61.898,6.948l-37.539-44.723c8.081,5.694,19.952,14.058,37.726,26.582l45.346-5.088
                  c0,0-66.685-29.258-106.918-47.052c-12.254-5.419-27.225,2.284-32.704,16.705c-3.937,10.366-34.858,91.771-39.883,105.002
                  c-5.437,14.312-0.029,29.891,12.679,34.718c4.24,2.336,0.112,1.14,81.622,16.344l-9.738,89.99
                  c-1.385,12.807,8.651,23.935,21.51,23.935c10.887,0,20.256-8.208,21.456-19.285L272.63,239.25
                  c1.215-11.227-6.419-21.496-17.52-23.567l-34.287-6.395l8.572-20.716c-2.912-6.19-24.572-52.255-27.337-58.133l43.744,52.117
                  c3.814,4.546,9.71,7,15.801,6.319l71.024-7.971c9.184-1.031,16.488-8.663,16.47-17.906
                  C349.077,152.069,339.64,143.875,329.08,145.061z"/>
              </svg>
    },
    {
      label : "Elektro terapie",
      object : "ElectroTherapy",
      image : <svg fill="#000000" height="60px" width="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
                  <path d="M23,11a1,1,0,0,1-1,1H19.659l-2.74,6.394a1.015,1.015,0,0,1-.982.6,1,1,0,0,1-.9-.724L12.064,7.865,8.97,20.242A1,1,0,0,1,8.057,21L8,21a1,1,0,0,1-.937-.648L4.307,13H2a1,1,0,0,1,0-2H5a1,1,0,0,1,.937.648l1.872,4.994L11.03,3.758a1,1,0,0,1,1.931-.032l3.228,11.3,1.892-4.415A1,1,0,0,1,19,10h3A1,1,0,0,1,23,11Z"/>
              </svg>
    },
        {
      label : "Tělocvična",
      object : "SportGym",
      image : <svg fill="#000000" height="60px" width="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 260 238" >

          <path d="M195.288,5.905C191.522,3.32,187.267,2,183,2c-7,0-13.984,3.181-18.352,9.369c-6.831,9.953-4.489,23.809,5.464,30.64
            s23.614,4.489,30.64-5.464S205.241,12.735,195.288,5.905z M247.981,47.502c-4.489-2.927-10.539-1.952-13.466,2.537l-20.687,29.274
            l-35.129-24.785L164.452,44.38c-5.66-4.098-12.295-6.05-18.93-6.05h-44.496c-3.318-0.39-6.635,1.171-8.587,4.098L66.678,79.312
            c-2.927,4.489-1.952,10.539,2.537,13.466c4.489,2.927,10.539,1.952,13.466-2.537l22.834-32.787h26.737L62.775,158.352l-43.52-11.514
            c-7.416-1.952-14.832,2.342-16.784,9.563c-1.952,7.416,2.342,14.832,9.563,16.784l53.083,14.247
            c3.318,0.781,7.221,0.585,10.539-1.366c2.537-1.366,3.903-4.098,5.464-6.05s24.005-34.348,24.005-34.348l42.545,30.25l8.587,48.595
            c1.366,7.416,8.587,12.49,16.003,11.319c7.416-1.366,12.49-8.587,11.319-16.003l-9.563-54.059c-0.585-3.513-2.927-6.831-5.855-8.782
            l-33.762-23.614l39.617-58.743l37.08,25.761c4.489,2.927,10.539,1.952,13.466-2.537l25.761-37.08
            C253.445,56.674,252.469,50.429,247.981,47.502z M232.828,163.494c13.902,0,25.172,11.27,25.172,25.172s-11.27,25.172-25.172,25.172
            s-25.172-11.27-25.172-25.172S218.926,163.494,232.828,163.494z"/>
              </svg>
    },
    {
      label : "Překážková dráha",
      object : "ObsticleCourse",
      image : <svg fill="#000000" height="60px" width="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" >

          <path d="M137.215,185.601c-3.121,2.374-3.708,6.827-1.326,9.934c2.374,3.12,6.827,3.713,9.94,1.339
            c3.12-2.382,3.707-6.834,1.325-9.954C144.781,183.813,140.329,183.212,137.215,185.601z"/>
          <path  d="M171.855,159.12c-3.12,2.381-3.707,6.834-1.332,9.947c2.381,3.107,6.834,3.714,9.954,1.332
            c3.106-2.382,3.693-6.834,1.318-9.947C179.415,157.338,174.969,156.745,171.855,159.12z"/>
          <path  d="M172.822,215.609c-2.278,1.747-2.72,5.032-0.967,7.318c1.747,2.284,5.033,2.734,7.318,0.987
            c2.299-1.753,2.727-5.047,0.974-7.338C178.399,214.298,175.127,213.856,172.822,215.609z"/>
          <path d="M198.495,202.569c-1.753-2.292-5.032-2.734-7.324-0.98c-2.292,1.753-2.727,5.032-0.98,7.324
            c1.746,2.286,5.032,2.72,7.324,0.981C199.806,208.14,200.235,204.854,198.495,202.569z"/>
          <path d="M455.841,297.571l-0.401-0.4c-3.562-3.562-8.967-4.528-13.544-2.416l-16.209,4.715
            c-3.403,1.567-7.352,1.463-10.665-0.29l-33.744-20.31c-1.553-0.821-3.272-1.298-5.025-1.38l-45.196,0.959
            c-2.975-0.151-5.791-1.401-7.897-3.506l-71.428-71.428c-2.947-2.948-4.155-7.214-3.196-11.274L275.265,79.38
            c0.214-0.911,0.324-1.836,0.324-2.768V12.026C275.59,5.384,270.205,0,263.565,0h-14.083c-6.641,0-12.026,5.384-12.026,12.026
            v61.252c0,1.036-0.131,2.064-0.4,3.065l-5.523,20.959c-0.449-0.67-0.766-1.395-1.263-2.044
            c-12.446-16.271-35.731-19.384-52.016-6.938c-6.6,5.04-10.99,11.867-13.109,19.288c-16.996-1.532-34.599,3.044-49.227,14.228
            c-14.635,11.19-23.664,26.971-26.654,43.774c-7.717,0.09-15.456,2.54-22.056,7.586c-16.27,12.44-19.391,35.724-6.944,52.002
            c12.44,16.285,35.738,19.392,52.009,6.952c0.201-0.151,0.373-0.324,0.566-0.483c9.271,7.952,20.254,13.192,31.79,15.566
            c0.303,0.414,0.594,0.836,0.904,1.236c1.519,1.988,3.182,3.783,4.908,5.496l-21.275,89.231c-0.249,1.16-0.676,2.285-1.257,3.321
            l-30.657,54.97c-3.023,5.419-1.428,12.24,3.68,15.76l9.202,6.344c2.706,1.864,6.061,2.54,9.278,1.864
            c3.217-0.67,6.02-2.63,7.76-5.419l30.27-48.75c0.38-0.608,0.704-1.257,0.974-1.926l17.651-44.726
            c1.526-3.852,4.916-6.648,8.982-7.408c4.072-0.759,8.242,0.628,11.045,3.672l24.126,26.66c3.045,3.3,3.99,8.022,2.465,12.24
            l-6.572,46.23c-0.594,1.63-0.822,3.362-0.676,5.088l5.716,54.432c0.27,3.245-0.794,6.469-2.934,8.919l-9.416,10.756
            c-2.347,2.678-3.382,6.262-2.83,9.782c0.552,3.521,2.638,6.614,5.688,8.442l11.397,6.841c4.729,2.838,10.783,2.092,14.684-1.808
            l18.445-18.446c2.251-2.251,3.521-5.316,3.521-8.498v-61.1c0-1.588,0.317-3.155,0.924-4.625l17.907-59.416
            c1.54-3.693,22.588-22.187,26.508-22.974l51.25-10.604c2.32-0.462,4.722-0.235,6.91,0.663l47.404,20.309
            c4.018,1.643,8.601,0.994,12.005-1.691l32.176-26.585c2.693-2.133,4.35-5.309,4.55-8.732
            C459.541,303.349,458.271,300.001,455.841,297.571z M74.623,214.228c-6.379-8.36-4.791-20.288,3.562-26.674
            c3.072-2.354,6.634-3.61,10.224-3.852c0.959,12.026,4.998,23.947,12.294,34.503C92.392,224.066,80.864,222.388,74.623,214.228z
            M189.237,102.672c8.346-6.385,20.282-4.784,26.668,3.569c6.24,8.152,4.839,19.729-3.017,26.212
            c-8.263-9.816-18.694-16.844-30.056-20.93C184.005,108.132,186.159,105.026,189.237,102.672z M165,247.529
            c-11.549-7.034-15.87-19.101-17.417-28.607c-10.424,2.265-21.69-1.428-28.593-10.465c-9.506-12.44-7.138-30.25,5.302-39.762
            c6.966-5.322,15.602-6.917,23.533-5.116c0.346-8.125,4.142-16.036,11.107-21.365c12.447-9.506,30.25-7.124,39.763,5.322
            c6.904,9.03,7.511,20.869,2.596,30.333c8.767,3.997,19.274,11.335,23.029,24.32l-28.758,21.98l-1.809,1.38L165,247.529z
            M211.003,246.246c-9.927,7.594-22.387,9.478-33.55,6.288l48.419-37.015C226.025,227.124,220.937,238.658,211.003,246.246z"/>
              </svg>
    },
  ];

  return (
    <div>
      <h1 className={title()}>Ceník</h1>
      <ProductPresenter headers={AvaliableHeaders}/>
    </div>
  );
}
